import { Map, List } from "immutable";
import { LINKS_GET_LINKS_SUCCESSFUL } from "UserAuthorized/actionTypes";
import SentLinkResponse from "contracts/responses/MagicLinkResponse";
const InitialState = {
  myLinks: List()
};

const linksMagicLinkReducer = (state = Map(InitialState), action) => {
  switch (action.type) {
    case LINKS_GET_LINKS_SUCCESSFUL:
      return state.set("myLinks", List(action.payload));
    default:
      return state;
  }
};

export default linksMagicLinkReducer;
